document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll(
    'nav[header-menu] .menu-list__list-item > a[aria-haspopup="true"]'
  );

  if (!triggers.length) return;

  function closeAll() {
    document
      .querySelectorAll('nav[header-menu] .menu-list__list-item.menu-item-open')
      .forEach((item) => {
        item.classList.remove('menu-item-open');
        const link = item.querySelector('a[aria-haspopup="true"]');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
  }

  // Отваряне/затваряне при клик
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const li = trigger.closest('.menu-list__list-item');
      const isOpen = li.classList.contains('menu-item-open');

      // затваряме всички
      closeAll();

      // ако не е бил отворен – отваряме
      if (!isOpen) {
        li.classList.add('menu-item-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Клик извън менюто – затваря всичко
  document.addEventListener('click', (e) => {
    if (!e.target.closest('nav[header-menu]')) {
      closeAll();
    }
  });
});
